import { render, staticRenderFns } from "./company-payroll-rule.vue?vue&type=template&id=35fe583a&scoped=true"
import script from "./company-payroll-rule.vue?vue&type=script&lang=js"
export * from "./company-payroll-rule.vue?vue&type=script&lang=js"
import style0 from "./company-payroll-rule.vue?vue&type=style&index=0&id=35fe583a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe583a",
  null
  
)

export default component.exports